interface Modal {
  id: string;
  state: boolean;
  toggle: (state: boolean) => void;
}

interface ModalService {
  modals: Modal[];
  registerModal: (id: string, toggle: (state: boolean) => void) => void;
  removeModal: (id: string) => void;
  toggleModal: (id: string, force?: boolean) => void;
  openModal: (id: string) => void;
  closeModal: (id: string) => void;
}

const ModalService: ModalService = {
  modals: [],

  registerModal: (id: string, toggle: (state: boolean) => void) => {
    ModalService.modals.push({ id, state: false, toggle });
  },

  removeModal: (id: string) => {
    ModalService.modals = ModalService.modals.filter(
      (modal: Modal) => modal.id !== id
    );
  },

  toggleModal: (id: string, force?: boolean) => {
    const modal = ModalService.modals.find((modal: Modal) => modal.id === id);

    if (modal) {
      modal.state = typeof force === "undefined" ? !modal.state : force;
      modal.toggle(modal.state);
    } else {
      console.error("Modal id does not exist");
    }
  },

  openModal: (id: string) => {
    ModalService.toggleModal(id, true);
  },

  closeModal: (id: string) => {
    ModalService.toggleModal(id, false);
  },
};

export default ModalService;
